import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findGoogleReviewRequestsWithPagination(page, limit, email = null, customerName = null, reviewGiven = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (email) {
        params.append('email', email);
    }

    if (customerName) {
        params.append('customerName', customerName);
    }

    // The "not reviewed yet" filter sends a 0, so an emptiness check would silently drop it.
    if (reviewGiven !== null && reviewGiven !== '') {
        params.append('reviewGiven', reviewGiven);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/google-review-requests?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch Google review requests');

    return response.json();
}

export async function updateGoogleReviewGiven(googleReviewRequestId, reviewGiven) {
    if (!googleReviewRequestId) {
        throw new Error("The googleReviewRequestId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/google-review-requests/${googleReviewRequestId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            reviewGiven : reviewGiven
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update the Google review request');
}
